
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { closeModal } from "../../store/actions/modalAction";
import { SNACK_BAR_VARIETNS, STATUS } from "../../utils/constants";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { getRepairingTicketStatusByIdApi, RepairingUpdateTicketApi } from "../../apis/repairing.api";
import UpdateCreateQueryUi from "./UpdateCreateQueryUi";
import { statusActionFilters, statusCountActionFilters } from "../../store/actions/statusAction";
import { FetchProblemApi } from "../../apis/problem.api";
import { fetchNotificationAction } from "../../store/actions/notificationAction";
import moment from "moment";
import { getProdutApi, ProductFindByIdApi } from "../../apis/product.api";

const UpdateCreateQueryController = ({ statusPass, fieldTicket, setTickets, id }) => {
  const [fields, setFields] = useState({
    id: id,
    err: "",
    createdAt: fieldTicket?.createdAt ? fieldTicket?.createdAt : "",
    ticket_no: fieldTicket?.ticketNo ? fieldTicket?.ticketNo : "",
    product_id: "",
    box_id: "",
    customer_phone: "",
    customer_name: "",
    customer_email: "",
    source_id: "",
    trakingId: "",
    problems: [],
    solved_in: "",
    customer_address: "",
    device_is: "",
    repairable_part: [],
    repairable_remarks: "",
    replace_remarks: "",
    other: "",
    conclusion: "",
    physical_damage: {
      damage_part: [],
      repairing_amount: null,
      remarks: ""
    },
    problem_solve_by_crm: {
      type_of_problem: "",
      remarks: ""
    },
    repairing_amount_status: "",
    repairing_amount: null,
    country:"",
    state:"",
    city:"",
    before_photo: "",
    after_photo: null,
  });

  const [validation, setvalidation] = useState(false);
  const [loading, setLoading] = useState(false);
  const validate = useValidate();
  const dispatch = useDispatch();
  const modalKey = 'Query';
  const title = "Query";
  const [listProblem, setlistProblem] = useState()
  const [listItem, setlistItem] = useState()

  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: true,
        value: fields.ticket_no,
        field: "ticket_no",
      },
      {
        required: true,
        value: fields.createdAt,
        field: "createdAt",
      },
      {
        required: true,
        value: fields.product_id,
        field: "product_id",
      },
      {
        required: false,
        value: fields.customer_email,
        field: "Email",
      },
      {
        required: false,
        value: fields.box_id,
        field: "Box Id",
      },
      {
        required: true,
        value: fields.customer_address,
        field: "customer_address",
      },
      {
        required: false,
        value: fields.other,
        field: "other",
      },
      {
        required: true,
        value: fields.customer_phone,
        field: "Phone",
      },
      {
        required: true,
        value: fields.customer_name,
        field: "Customer Name",
      },
      {
        required: true,
        value: fields.source_id,
        field: "Source",
      },
      {
        required: true,
        value: fields.problems,
        field: "Problems",
      },
      {
        required: false,
        value: fields.solved_in,
        field: "solved_in",
      },
      {
        required: false,
        value: fields.conclusion,
        field: "conclusion",
      },
      {
        required: statusPass === STATUS.REPAIR_START && true,
        value: fields.device_is,
        field: "Device",
      },
      {
        required: (statusPass === STATUS.REPAIR_START && fields.device_is === "Repairable") && true,
        value: fields?.repairable_part?.length,
        field: "Repairable Part",
      },
      {
        required: statusPass === STATUS.REPAIR_START && validation && fields.device_is === "Repairable"&& true,
        value: fields.repairing_amount,
        field: "Repairing Amount",
      },
      {
        required: (statusPass === STATUS.REPAIR_START && fields.device_is === "Repairable") && true,
        value: fields?.repairable_remarks,
        field: "Remarks",
      },
      {
        required: (statusPass === STATUS.REPAIR_START && fields.device_is === "Replace") && true,
        value: fields?.replace_remarks,
        field: "Remarks",
      },

      {
        required: (statusPass === STATUS.REPAIR_START && fields.device_is === "physical_damage") && true,
        value: fields?.physical_damage?.damage_part?.length,
        field: "Damage Part",
      },

      {
        required: (statusPass === STATUS.REPAIR_START && fields.device_is === "physical_damage") && true,
        value: fields.physical_damage.repairing_amount,
        field: "Cost",
      },
      {
        required: (statusPass === STATUS.REPAIR_START && fields.device_is === "physical_damage") && true,
        value: fields.physical_damage.remarks,
        field: "Remarks",
      },
    ],
    [fields, statusPass, validation]
  );

  const filters = useMemo(() => ({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ['customer_name'],
    role: "",
    sort: "createdAt",
    sortDirection: -1,
  }), []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationResponse = validate(validationSchemaForUpdate)
    if (validationResponse === true) {
      setLoading(true)
      dispatch(callApiAction(
        async () => await RepairingUpdateTicketApi({ ...fields, product_id: fields.product_id?._id, source_id: fields.source_id?._id, country: fields.country?._id ? fields.country?._id : fields.country, state: fields.state?._id ? fields.state?._id : fields.state, city: fields.city?._id ? fields.city?._id : fields.city }),
        (response) => {

          dispatch(fetchNotificationAction());
          dispatch(closeModal("UpdateQuery"))
          dispatch(callSnackBar("Updated Successfully", SNACK_BAR_VARIETNS.suceess));
          dispatch(statusActionFilters(filters));
          dispatch(statusCountActionFilters(-1));
          setLoading(false)
        }, (err) => {
          setFields({ ...fields, err });
          setLoading(false);
        }
      ))
    } else {
      setFields({ ...fields, err: validationResponse })
      setLoading(false)
    }
  };

  const fetchList = (id) => {
    return new Promise((resolve, reject) => {
      dispatch(
        callApiAction(
          async () => await ProductFindByIdApi({ id }),
          (response) => {
            const problems = response?.problems || [];
            setlistProblem(problems);
            setlistItem(response?.item || [])
            resolve(problems);
          },
          (err) => {
            console.log("Error", err);
            reject(err);
          }
        )
      );
    });
  };

  const fetchById = useCallback((id) => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getRepairingTicketStatusByIdApi({ id }),
        async (response) => {
          setLoading(false);
          setFields(prev => ({ ...prev, ...response }));
          try {
            const data = await  fetchList(response?.product_id?._id);
            const todayDate = moment();
            const warrantyDate = moment(response?.warrenty_date);
            const SelectedProblem = data.filter(problem => response.problems.some(p => p.toLowerCase() === problem.name.toLowerCase())) || []
            for (const item of SelectedProblem) {
              console.log("Today Date",todayDate);  
              console.log("Warranty Date",warrantyDate);
              console.log("Warrantyss",Math.trunc((new Date(todayDate) - new Date(warrantyDate)) / (1000 * 60 * 60 * 24)) / 365)
              console.log("Is Warranty",item.warrenty)

              const isYear = 
              response?.is_warranty_3_yr ? warrantyDate.isValid() && Math.trunc((new Date(todayDate) - new Date(warrantyDate)) / (1000 * 60 * 60 * 24)) / 365 <= 3 : warrantyDate.isValid() && Math.trunc((new Date(todayDate) - new Date(warrantyDate)) / (1000 * 60 * 60 * 24)) / 365 <= item.warrenty;
              if (!isYear) {
                setvalidation(true);
                break;
              } else {
                setvalidation(false);
              }
            }

          } catch (err) {
            console.error("Error fetching list in fetchById:", err);
          }
        },
        (err) => {
          setFields(prev => ({ ...prev, err }));
          setLoading(false);
        }
      )
    );
  }, [dispatch])

  useEffect(() => {
    if (id) fetchById(id);
  }, [id, fetchById]);

  return (
    <UpdateCreateQueryUi
      statusPass={statusPass}
      listProblem={listProblem}
      modalKey={modalKey}
      title={title}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
      validation={validation}
      setvalidation={setvalidation}
      listItem={listItem}
    />
  );
};
export default memo(UpdateCreateQueryController);
